export type Feature =
  | 'CMP_SITES'
  | 'CMP_ANALYTICS'
  | 'CMP_OVERRIDES'
  | 'CMP_EXPORTS'
  | 'CMP_SCANS'
  | 'CMP_CONFIG'
  | 'CMP_ADMIN';

export async function loadCatalog(): Promise<Record<Feature, string[]>> {
  const mod = await import('./capabilities.catalog.json');
  return (mod.default ?? mod) as Record<Feature, string[]>;
}
